import {useState} from "../../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../../__snowpack__/pkg/hox.js";
import {axios} from "../../../lib/axios.js";
import {handleError} from "../../../lib/errorHandler.js";
const useShopInfo = () => {
  const [shopInfo, setShopInfo] = useState();
  return {
    shopInfo,
    setShopInfo
  };
};
export const useShopInfoModel = createModel(useShopInfo);
export const useShopChange = () => {
  const [tagData, setTagData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [attributeData, setAttributeData] = useState([]);
  const [taxClassData, setTaxClassData] = useState([]);
  const [shippingData, setShippingData] = useState([]);
  const getCategoryData = async (params) => {
    try {
      const {data = []} = await axios.get(`/saas/product-category/channels/get-categories-by-shop`, {
        params
      });
      setCategoryData(Array.isArray(data) ? data : []);
      return data;
    } catch (error) {
      setCategoryData([]);
      handleError(error);
    } finally {
    }
  };
  const getShopIdCategoryData = async (params) => {
    try {
      const {data = []} = await axios.post(`/saas/product-category/channels/get-shop-categories`, params);
      setCategoryData(Array.isArray(data) ? data : []);
      return data;
    } catch (error) {
      setCategoryData([]);
      handleError(error);
    } finally {
    }
  };
  const getTagData = async (params) => {
    try {
      const {data} = await axios.post("/saas/shop/product-tag/list", params);
      setTagData(data ? data : []);
      return data;
    } catch (error) {
      setTagData([]);
      handleError(error);
    } finally {
    }
  };
  const getTaxClassData = async (params) => {
    try {
      const {data} = await axios.post("/saas/shop/tax-classes/list", params);
      setTaxClassData(data ? data : []);
      return data;
    } catch (error) {
      setTaxClassData([]);
      handleError(error);
    } finally {
    }
  };
  const getShippingData = async (params) => {
    try {
      const {data} = await axios.get("/saas/shop/get-logistics-channels", {
        params
      });
      setShippingData(data ? data : []);
      return data;
    } catch (error) {
      setShippingData([]);
      handleError(error);
    } finally {
    }
  };
  const getAttributeData = async (params) => {
    try {
      const {data} = await axios.post("/saas/shop/product-attribute/list", params);
      setAttributeData(data ? data : []);
      return data;
    } catch (error) {
      setAttributeData([]);
      handleError(error);
    } finally {
    }
  };
  const resetShopChangeData = () => {
    setTagData([]);
    setCategoryData([]);
    setAttributeData([]);
    setTaxClassData([]);
    setShippingData([]);
  };
  return {
    tagData,
    getTagData,
    categoryData,
    getCategoryData,
    getShopIdCategoryData,
    attributeData,
    getAttributeData,
    taxClassData,
    getTaxClassData,
    shippingData,
    getShippingData,
    resetShopChangeData
  };
};
export const useShopChangeModel = createModel(useShopChange);
const useVariationOptions = () => {
  const defaultVariation = {
    variationTypeData: {
      label: "",
      value: ""
    },
    options: [],
    variation: true,
    visible: true
  };
  const defaultData = [
    {
      variationTypeData: {
        label: "",
        value: ""
      },
      options: [],
      variation: true,
      visible: true
    }
  ];
  const [data, setData] = useState([]);
  const [variations, setVariations] = useState([]);
  const handleSetVariationOptions = (values) => {
    setData(values);
  };
  return {
    defaultVariation,
    defaultData,
    variationOptions: data,
    variations,
    setVariations,
    handleSetVariationOptions
  };
};
export const useVariationOptionsModel = createModel(useVariationOptions);
export default {};
